// removed by extract-text-webpack-plugin
module.exports = {"drag-card":"_mlwq","drag-txt":"_1M23","dash":"_3TPe"};


//////////////////
// WEBPACK FOOTER
// ./checkout/components/draganddrop/style.css
// module id = dDmy
// module chunks = 4